export const formRecord = {
    for: [{ host: 'brick', kind: 'form' }],
    requires: ['html', 'store'],
    ns: 'record',
    options: {},

    brick: {
        // We could expose methods to get/set the current record directly if needed
        getRecord: function () {
            const data = this.brick.store.data();
            return (data && data.length) ? data[0] : null;
        }
    },

    extension: {
        _bind: function (record) {
            const root = this.brick.html.element();
            if (!root) return;

            // Iterate over all form fields
            const inputs = root.querySelectorAll('input, select, textarea');
            for (let i = 0; i < inputs.length; i++) {
                const input = inputs[i];
                const name = input.name || input.id;
                if (!name) continue;

                // If record has this field, set value
                if (record && Object.prototype.hasOwnProperty.call(record, name)) {
                    input.value = record[name];
                } else {
                    // Optional: clear if not in record? Or leave defaults?
                    // Typically binding means reflecting state. If state is null, clear.
                    // But if record doesn't have the key, maybe leave it?
                    // Let's assume strict binding for now: if record is null, clear.
                    if (!record) input.value = '';
                }
            }
        }
    },

    events: [
        {
            for: 'brick:status:ready',
            on: {
                fn: function (ev) {
                    // Initial bind will be triggered by store:data:load after phase
                    // No need to load here - store.js already triggers load
                }
            }
        },
        {
            for: 'store:data:*',
            after: {
                fn: function (ev) {
                    const data = ev.data; //this.brick.store.load();
                    // We bind the first record
                    const record = (data && data.length) ? data[0] : null;
                    this._bind(record);
                }
            }
        },
        {
            for: 'dom:row:focus',
            after: {
                fn: function (ev) {
                    //console.warn("Form > master focused a row", ev);
                    const record = ev.data.row;
                    //console.log("\trecord", record);
                    // We bind the first record
                    this._bind(record);
                }
            }
        }
    ],

    init: function () {
        return true;
    },

    destroy: function () {
    }
};


export default formRecord;

